"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * CMC Markets Developer Portal
 * ### Invoke API using this Dev Portal    * Open `API Servers` and select the API Server to be used    * Open `Authentication`, select `Request Body` instead of *Authorization Header* and `Get Token` to fetch a JWT token    * Invoke the function  ### Generate Client Code  ```docker run --rm -v ${PWD}:/local openapitools/openapi-generator-cli generate -i https://api-signup.invest.cmcmarkets.com.au/developer/swagger.json -g typescript-fetch -o /local/ts```
 *
 * The version of the OpenAPI document: 1.4.99
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api"), exports);
__exportStar(require("./configuration"), exports);
